(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function(){
  var THRESHOLD = 39900;

  function updateShipping(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      var fill = document.querySelector('.gs-cart-ship__fill');
      var msg  = document.querySelector('.gs-cart-ship__msg');
      if(!fill) return;
      var pct = Math.min((c.total_price/THRESHOLD)*100,100);
      fill.style.width = pct+'%';
      if(c.total_price >= THRESHOLD){
        fill.classList.add('gs-cart-ship__fill--done');
        if(msg){ msg.innerHTML='\u00a1Tienes env\u00edo gratis! \uD83C\uDF89'; msg.classList.add('gs-cart-ship__msg--done'); }
      } else {
        fill.classList.remove('gs-cart-ship__fill--done');
        var rem = Math.ceil((THRESHOLD - c.total_price)/100);
        if(msg){ msg.innerHTML='Te faltan <strong>S/ '+rem+'</strong> para env\u00edo gratis'; msg.classList.remove('gs-cart-ship__msg--done'); }
      }
    }).catch(function(){});
  }

  function initDiscount(){
    var btn = document.querySelector('.gs-cart-disc__btn');
    if(!btn||btn._pf) return;
    btn._pf = true;
    btn.addEventListener('click',function(){
      var inp = document.querySelector('.gs-cart-disc__input');
      var msg = document.querySelector('.gs-cart-disc__msg');
      if(!inp||!inp.value.trim()) return;
      btn.textContent='...'; btn.disabled=true;
      fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{discount_code:inp.value.trim().toUpperCase()}})})
        .then(function(){
          if(msg){msg.textContent='\u2714 C\u00f3digo aplicado';msg.className='gs-cart-disc__msg gs-cart-disc__msg--ok';}
          btn.textContent='APPLY';btn.disabled=false;
        }).catch(function(){
          if(msg){msg.textContent='C\u00f3digo inv\u00e1lido';msg.className='gs-cart-disc__msg gs-cart-disc__msg--err';}
          btn.textContent='APPLY';btn.disabled=false;
        });
    });
  }

  function initUpsell(){
    if(document._gsUpsell) return;
    document._gsUpsell = true;
    document.addEventListener('click',function(e){
      var btn = e.target.closest('.gs-upsell__add');
      if(!btn) return;
      var vid = btn.dataset.variantId;
      if(!vid) return;
      var orig = btn.innerHTML;
      btn.textContent='...'; btn.disabled=true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:vid,quantity:1})})
        .then(function(r){return r.json();})
        .then(function(){
          btn.innerHTML='\u2714 Added';
          btn.classList.add('gs-upsell__add--added');
          updateShipping();
        }).catch(function(){btn.innerHTML=orig;btn.disabled=false;});
    });
  }

  function initScrollButtons(){
    var wrap  = document.getElementById('gs-scroll-wrap');
    var panel = document.getElementById('gs-scroll-btns');
    var btnUp = document.getElementById('gs-scroll-up');
    var btnDn = document.getElementById('gs-scroll-down');
    if(!wrap||!panel||!btnUp||!btnDn) return;
    if(wrap._gsScrollInit) return;
    wrap._gsScrollInit = true;
    var hideTimer = null;
    function canScroll(){ return wrap.scrollHeight > wrap.clientHeight + 8; }
    function show(){ if(!canScroll()) return; panel.classList.add('gs-scroll-btns--visible'); syncDisabled(); clearTimeout(hideTimer); hideTimer = setTimeout(hide, 2200); }
    function hide(){ panel.classList.remove('gs-scroll-btns--visible'); }
    function syncDisabled(){ btnUp.disabled = wrap.scrollTop <= 4; btnDn.disabled = wrap.scrollTop + wrap.clientHeight >= wrap.scrollHeight - 4; }
    wrap.addEventListener('scroll', function(){ show(); }, {passive:true});
    wrap.addEventListener('mouseenter', function(){ show(); });
    wrap.addEventListener('mouseleave', function(){ clearTimeout(hideTimer); hideTimer = setTimeout(hide, 700); });
    btnUp.addEventListener('click', function(){ wrap.scrollBy({top: -220, behavior: 'smooth'}); setTimeout(syncDisabled, 350); });
    btnDn.addEventListener('click', function(){ wrap.scrollBy({top: 220, behavior: 'smooth'}); setTimeout(syncDisabled, 350); });
    wrap.addEventListener('touchstart', function(){ show(); }, {passive:true});
    syncDisabled();
  }

  function init(){
    updateShipping();
    initDiscount();
    initUpsell();
    initScrollButtons();
    document.addEventListener('cart:updated', updateShipping);
    document.addEventListener('cart-updated', updateShipping);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  var obs = new MutationObserver(function(){
    updateShipping();
    initDiscount();
    initScrollButtons();
  });
  var el = document.querySelector('cart-drawer-component');
  if(el) obs.observe(el, {childList:true, subtree:true});
})();
  } catch(e) { console.error(e); }
})();

})();
